export const AuthPath = 'auth';
